// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2UA7r","header":"PatientBlock_header__2fAAT","label":"PatientBlock_label__2pkkJ","option":"PatientBlock_option__2Gy7t"};